module.exports = __webpack_public_path__ + "img/404-a4f28b.png";